<template>
  <el-container class="index-con">
    <el-aside
      :class="showclass"
      style="transition: all 0.7s;border-right: 1px solid #f5f5f5;"
    >
      <!-- 系统LOGO -->
      <div class="logo">
        <img
          v-show="showclass == 'asideshow'"
          src="@/assets/img/group_logo.png"
          style="width: 80px;"
          alt="客莱宝"
        />
        <img
          v-show="showclass == 'aside'"
          src="@/assets/img/group_logo2.png"
          style="width: 26px;"
          alt="客莱宝"
        />
      </div>
      <div style="flex:1;overflow-y: scroll;overflow-x: hidden;">
        <Leftnav :user="user"></Leftnav>
      </div>

      <div class="aside-bottom">
        <el-button
          class="buttonimg"
          :icon="collapsed ? iconOpen : iconClose"
          @click="toggle(collapsed)"
        >
        </el-button>
      </div>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <Navcon1 :user="user"></Navcon1>
      </el-header>
      <el-header class="tags-container">
        <TagsView />
      </el-header>
      <el-main
        class="index-main"
        id="indexMain"
        style="background-color: #F4F7FC;"
      >
        <!--  -->
        <div
          class="main-wrap"
          :class="
            key == '/index' ||
            key == '/groupChat/chat' ||
            key == '/dataChat/chat' ||
            key == '/commodityBoard/index' ||
            key.includes('/group/detail')
              ? 'index-style'
              : ''
          "
        >
          <transition name="fade-transform" mode="out-in">
            <keep-alive>
              <router-view :key="key" v-if="isKeepAlive"></router-view>
            </keep-alive>
          </transition>
          <transition name="fade-transform" mode="out-in">
            <router-view :key="key" v-if="!isKeepAlive"></router-view>
          </transition>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import Navcon from "../components/Navcon";
import Navcon1 from "../components/Navcon1";
import Leftnav from "../components/Leftnav";
import TagsView from "../components/TagsView";
import {
  getLoginUserInfo,
  analysisJWT,
} from "../api/loginuserinfo/loginuserinfo.js";
import { mapMutations } from "vuex";
export default {
  name: "Index",
  data() {
    return {
      showclass: "asideshow",
      showtype: false,
      user: "",
      collapsed: true,
      iconOpen: "iconfont icon-fold-open",
      iconClose: "iconfont icon-fold-close",
    };
  },
  components: {
    Navcon1,
    Leftnav,
    TagsView,
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
    isKeepAlive() {
      console.log("this.$route.meta", this.$route.meta.keepAlive);
      return this.$route.meta.keepAlive;
    },
  },
  methods: {
    analysisJWTMethod(Authorization) {
      analysisJWT(Authorization)
        .then((res) => {
          if (res.error.code == 200) {
            this.user = res.data;
            // console.log(res.data)
            var arr = res.data.staffRoleUrl;
            // arr.push("/main")
            arr.push("/login");
            arr.push("/not-found");
            // console.log('testtest....')
            localStorage.setItem("url", arr);
            localStorage.setItem(
              "routerList",
              JSON.stringify(this.user.staffRole),
            );
            localStorage.setItem(
              "myDepartment",
              JSON.stringify(this.user.departmentId),
            );
            localStorage.setItem("userId", JSON.stringify(this.user.userid));
            localStorage.setItem("userName", JSON.stringify(this.user.name));

            this.$store.commit("tagsView/SET_ROLE_AUTHIRITY", [
              ...this.user.staffFunBoRole,
              {
                pname: "敏感行为监控",
                purl: "/chat/StaffChatSupervise",
                cfunBu: [],
              },
            ]);
            this.$store.commit("tagsView/SS_ROUTER", this.user.staffRole);
            // console.log('请求')
            // this.$router.push({ path: arr[0] })
          }
        })
        .catch((err) => {
          console.log("错误", err);
        });
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
  },
  async created() {
    await this.analysisJWTMethod(localStorage.getItem("Authorization"));
    // 监听
    this.$root.Bus.$on("toggle", (value) => {
      if (value) {
        this.showclass = "asideshow";
      } else {
        setTimeout(() => {
          this.showclass = "aside";
        }, 300);
      }
    });
  },
  beforeUpdate() {},
};
</script>
<style lang="scss" scoped>
.index-con {
  height: 100%;
  width: 100%;
  // border: 1px solid #f00;
  /* box-sizing: border-box; */
}
.logo {
  height: 49px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.aside {
  display: flex;
  flex-direction: column;
  width: 64px !important;
  height: 100%;
  background-color: white;
  margin: 0px;
}
.asideshow {
  display: flex;
  flex-direction: column;
  width: 210px !important;
  height: 100%;
  overflow-x: hidden;
  background-color: white;
  margin: 0px;
}
.buttonimg {
  height: 40px;
  background-color: transparent;
  float: left;
  border: none;
}
.aside-bottom {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f0f0f0;
  height: 40px;
}
.index-header {
  padding: 0;
  height: 50px !important;
  background-color: #fff;
  border-bottom: 1px solid #f5f5f5;
  z-index: 1999;
}
.tags-container {
  padding: 0;
  height: 38px !important;
  background-color: #f4f7fc;
  z-index: 1999;
  ::-webkit-scrollbar {
    width: 8px;
    height: 6px;
    background-color: #f4f7fc !important;
  }
}
.index-main {
  padding: 15px 18px 18px 18px;
  height: 100%;
  width: 100%;
  .main-wrap {
    background-color: white;
    border-radius: 4px;
    padding: 15px 19px;
    box-sizing: border-box;
    height: 100%;
    // min-width: 1190px;
  }
  .index-style {
    padding: 0;
    background-color: #f4f7fc;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background-color: #f4f7fc !important;
    }
  }
}
/* 消失时间持续0.5s */
.fade-transform-enter-active {
  transition: all 0.5s;
}
/* 显示时间持续0.5s */
.fade-leave-active {
  transition: all 0.5s;
}
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
